'use client';

import { usePathname } from 'next/navigation';
import { JSX } from 'react';
import { twMerge } from 'tailwind-merge';

export default function AccountPageTab({ title, path }: { title: string; path: string }): JSX.Element {
    const pathname = usePathname();
    const isSelected = pathname?.includes(path);

    return (
        <a className={twMerge('w-full border-b border-gray-200 cursor-pointer')} href={`/member/${path}`}>
            <div
                className={twMerge(
                    'w-full h-full px-8 py-4 hover:px-5 hover:border-l-8 hover:border-pink-500 leading-tight',
                    isSelected && 'border-l-8 border-pink-500 font-bold px-5',
                )}
            >
                {title}
            </div>
        </a>
    );
}
